export default __webpack_public_path__ + "images/9f78643ec873aeb148e04ccc01f4f48e.png";